import { Box, Text, Checkbox } from "@chakra-ui/react";
import { FormAcordo } from "core/features/acordo/typings";
import moment from "moment";
import { Control } from "react-hook-form";
import { UseFormWatch } from "react-hook-form";
import Field from "ui/components/Input/Field";
import SelectPessoas from "ui/components/Input/SelectPessoas";
import { Row, Col } from "antd";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import { FaCalendarDay } from "react-icons/fa";
import FieldShow from "./components/FieldShow";
import { formatMoney } from "infra/helpers/number";

interface ConfirmacaoProps {
  control: Control<FormAcordo>;
  watch: UseFormWatch<FormAcordo>;
  total: number;
  unidadeId: string;
}

function Confirmacao({ control, total, unidadeId, watch }: ConfirmacaoProps) {
  const primeiraParcela = watch("parcelas")[0];
  return (
    <>
      <Text my="32px" fontSize="16px" fontWeight={"bold"}>
        Escolher responsável
      </Text>

      <Row>
        <Col sm={8}>
          <Field
            label="Responsável"
            name="pessoaResponsavelId"
            control={control}
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectPessoas
                showSearch
                tenantId={null}
                isInvalid={isInvalid}
                tipoEntidades={[TipoEntidadeEnum.Condomino]}
                {...field}
                unidadeId={unidadeId}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
        </Col>
      </Row>

      <Text my="32px" fontSize="16px" fontWeight={"bold"}>
        Boleto
      </Text>

      <Box mb={4}>
        <Field
          control={control}
          name="gerarBoletoAutomatico"
          render={({ field }) => (
            <Checkbox
              isChecked={field.value}
              onChange={() => field.onChange(!field.value)}
            >
              <Text fontSize="12px">Gerar boleto automático</Text>
            </Checkbox>
          )}
        />
      </Box>

      <Box mb={12}>
        <Field
          control={control}
          name="enviarBoletoEmail"
          render={({ field }) => (
            <Checkbox
              isChecked={field.value}
              onChange={() => field.onChange(!field.value)}
            >
              <Text fontSize="12px">
                Enviar boleto automaticamente no email
              </Text>
            </Checkbox>
          )}
        />
      </Box>

      <Text my="32px" fontSize="16px" fontWeight={"bold"}>
        Revisar detalhes
      </Text>

      <Row gutter={32}>
        <Col sm={8}>
          <FieldShow label="Valor total" value={formatMoney(total || 0)} />
        </Col>
        <Col sm={8}>
          <FieldShow
            label="Valor da primeira parcela"
            value={primeiraParcela ? formatMoney(primeiraParcela.valor) : ""}
          />
        </Col>
        <Col sm={8}>
          <FieldShow
            label="Primeira parcela em"
            value={
              primeiraParcela
                ? moment(primeiraParcela.dataVencimento).format("DD/MM/YYYY")
                : ""
            }
            icone={<FaCalendarDay />}
          />
        </Col>
      </Row>
    </>
  );
}

export default Confirmacao;
